import { render } from "./CarForm.vue?vue&type=template&id=2f40fb6b&scoped=true"
import script from "./CarForm.vue?vue&type=script&lang=js"
export * from "./CarForm.vue?vue&type=script&lang=js"

import "./CarForm.vue?vue&type=style&index=0&id=2f40fb6b&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f40fb6b"]])

export default __exports__